import Global from '@/global'
import { platformHttp } from '@/utils/http'

const apis = {
  getSysNotices: '/appInterface/api/v1/notice/hileia',
  getAgreementStatus: '/api/user/latestVersionCheck',
  setAgreementCheck: '/api/user/latestVersionAgree'
}

/**
 * 获取公告
 */
export function getSysNotices() {
  return platformHttp.get(apis.getSysNotices, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

/**
 * 获取协议状态
 */
export function getAgreementStatus() {
  return platformHttp.get(apis.getAgreementStatus)
}

/**
 * 同意协议更新
 */
export function setAgreementUpdate() {
  return platformHttp.get(apis.setAgreementCheck)
}
